import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RemoveCircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"remove_circle"}/>
}
